/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import clsx from 'clsx';

import Typography from '../Typography';

import s from './styles.module.less';

const hasDragged = ({ destination, source }) => destination && source.index !== destination.index;

const SortableList = ({
  as: List = 'ul',
  onDragEnd,
  droppableId,
  children,
  className,
  placeholder,
  space,
  ...props
}) => (
  <DragDropContext
    onDragEnd={(result, provided) => {
      if (!hasDragged(result)) return;

      // eslint-disable-next-line no-unused-expressions
      onDragEnd?.(result, provided);
    }}
  >
    <Droppable droppableId={droppableId}>
      {(provided) => (
        <List
          className={clsx(className, s.list, s[space], { [s.placeholder]: placeholder })}
          {...props}
          {...provided.droppableProps}
          ref={provided.innerRef}
        >
          {placeholder ? (
            <>
              <Typography.Title level={3}>Oops!</Typography.Title>
              <Typography.Text>
                <div>There&apos;s nothing to see here yet.</div>
                <div>Get started using the options above.</div>
              </Typography.Text>
            </>
          ) : (
            children
          )}
          {provided.placeholder}
        </List>
      )}
    </Droppable>
  </DragDropContext>
);

export default SortableList;
